import React, { createContext, FunctionComponent, useContext } from "react";
import { AutomaticMessageFormType } from "src/scenes/orgAdmin/formTemplates/types/editMessagesDraft";
import { State } from "src/scenes/orgAdmin/formTemplates/types/editMessagesState";
import * as GQL from "src/types/graphql";
import { Action, useFormTemplateEditMessagesProcessor } from "./processor";

type ContextValue = {
  state?: State;
  dispatch?: (action: Action) => void;
  messageTemplateType?: GQL.message_template_type_enum;
  formTemplateId?: uuid;
};

const EditFormTemplateEditMessagesContext = createContext<ContextValue>({
  state: undefined,
  dispatch: undefined,
  messageTemplateType: undefined,
  formTemplateId: undefined,
});

type Props = {
  children: React.ReactNode;
  editMessagesInitialValues: AutomaticMessageFormType;
  messageTemplateType: GQL.message_template_type_enum;
  formTemplateId: uuid;
};

export const EditFormTemplateEditMessagesProvider: FunctionComponent<Props> = (
  props
) => {
  const { children, editMessagesInitialValues, messageTemplateType } = props;
  const formTemplateEditMessagesState = useFormTemplateEditMessagesProcessor(
    { editMessages: editMessagesInitialValues },
    messageTemplateType
  );

  return (
    <EditFormTemplateEditMessagesContext.Provider
      value={{
        ...formTemplateEditMessagesState,
        messageTemplateType,
      }}
    >
      {children}
    </EditFormTemplateEditMessagesContext.Provider>
  );
};

export function useEditFormTemplateEditMessagesContext() {
  const context = useContext<ContextValue>(EditFormTemplateEditMessagesContext);

  if (context === undefined) {
    throw new Error(
      "useEditFormTemplateEditMessagesContext must be used within a FormTemplateEditMessagesProvider"
    );
  }

  return context;
}
